import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const Export16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M8.6087 5.01739C8.6087 4.68122 8.33617 4.4087 8 4.4087C7.66383 4.4087 7.3913 4.68122 7.3913 5.01739V9.93917L6.29998 8.84785C6.06227 8.61014 5.67686 8.61014 5.43915 8.84785C5.20144 9.08556 5.20144 9.47096 5.43915 9.70867L7.56959 11.8391C7.62795 11.8975 7.69521 11.9415 7.767 11.9712C7.83877 12.001 7.91747 12.0174 8 12.0174C8.08253 12.0174 8.16123 12.001 8.233 11.9712C8.30479 11.9415 8.37205 11.8975 8.43041 11.8391L10.5608 9.70867C10.7986 9.47096 10.7986 9.08556 10.5608 8.84785C10.3231 8.61014 9.93773 8.61014 9.70002 8.84785L8.6087 9.93917V5.01739Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M8 2.21739C4.80635 2.21739 2.21739 4.80635 2.21739 8C2.21739 11.1936 4.80635 13.7826 8 13.7826C11.1936 13.7826 13.7826 11.1936 13.7826 8C13.7826 4.80635 11.1936 2.21739 8 2.21739ZM1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
